import _ from 'lodash';


module.exports = {
    prepareSlides: function (contents) {
        let cycle_times = [];
        for (var i=0; i< contents.images.length; i++){
            cycle_times[i]=5; //default
            if (contents.slide_cycle_time){
                    cycle_times[i]=contents.slide_cycle_time;
            }
            if (_.has(contents, 'cycle_overrides['+i+']')){
                if (contents.cycle_overrides[i]!==0){
                    cycle_times[i]=contents.cycle_overrides[i];
                }
            }
        }
        contents.cycle_times = cycle_times;
        return contents;
    },
}


// WEBPACK FOOTER //
// ./src/utils/slideshowHelpers.js